var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.913,
    height: 36.093,
    viewBox: "0 0 36.913 36.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#56aafe;}.c{fill:#0478ec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.683 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M263.966,81.638a1.642,1.642,0,0,1,1.631-1.631q6.98,0,13.96,0a1.641,1.641,0,0,1,1.63,1.631q0,17.229,0,34.458-2.05,0-4.1,0c.006-.546.007-1.092,0-1.636q-4.508,0-9.018,0c-.008.547-.005,1.093,0,1.639h-4.1q0-10.394-.005-20.79c.012-4.556,0-9.112.006-13.668m3.28,2.47q-.009,2.049,0,4.1,2.049.008,4.1,0,.009-2.05,0-4.1-2.05-.012-4.1,0m6.561,0q-.006,2.049,0,4.1,2.05.009,4.1,0c0-1.367.006-2.734,0-4.1q-2.05-.011-4.1,0m-6.561,6.561q-.009,2.05,0,4.1c1.367.007,2.734.005,4.1,0q.009-2.05,0-4.1-2.05-.008-4.1,0m6.563,0q-.012,2.049,0,4.1,2.05.012,4.1,0,.011-2.05,0-4.1c-1.366-.006-2.732-.008-4.1,0m-6.562,6.562q-.012,2.049,0,4.1c1.367.009,2.734.007,4.1,0q.009-2.05,0-4.1-2.049-.008-4.1,0m6.562,0q-.012,2.049,0,4.1,2.047.014,4.1,0,.015-2.049,0-4.1Q275.858,97.22,273.81,97.233Z",
    transform: "translate(-263.96 -80.005)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.097)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M295.967,119.966q2.05-.012,4.1,0,.008,2.049,0,4.1-2.049.011-4.1,0Q295.956,122.015,295.967,119.966Z",
    transform: "translate(-272.998 -119.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M359.971,119.969q2.05-.008,4.1,0c.007,1.367.005,2.734,0,4.1q-2.05.008-4.1,0Q359.963,122.019,359.971,119.969Z",
    transform: "translate(-330.44 -119.964)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M295.97,183.97q2.049-.006,4.1,0,.009,2.052,0,4.1c-1.366,0-2.733.006-4.1,0Q295.96,186.02,295.97,183.97Z",
    transform: "translate(-273 -177.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M359.967,183.965c1.366-.009,2.732-.007,4.1,0q.012,2.049,0,4.1-2.05.009-4.1,0Q359.957,186.014,359.967,183.965Z",
    transform: "translate(-330.434 -177.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72,217.631A1.644,1.644,0,0,1,73.627,216q8.21,0,16.421,0a1.7,1.7,0,0,1,1.629,1.357q.022,10.4.005,20.79-9.845,0-19.688,0,0-10.256,0-20.513m4.1,2.472q-.012,2.047,0,4.093,2.046.011,4.092,0,.014-2.046,0-4.092-2.047-.012-4.093,0m7.382,0q-.008,2.047,0,4.1,2.047.008,4.094,0,.009-2.047,0-4.1-2.047-.009-4.1,0M76.1,226.666q-.014,2.046,0,4.092,2.046.012,4.092,0,.011-2.047,0-4.093-2.047-.012-4.092,0m7.382,0c-.008,1.365-.006,2.728,0,4.093q2.047.012,4.1,0c.005-1.366.007-2.731,0-4.1C86.211,226.66,84.847,226.656,83.482,226.665Z",
    transform: "translate(-71.993 -206.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M295.967,247.967q2.049-.012,4.1,0,.012,2.05,0,4.1c-1.367.006-2.734.008-4.1,0Q295.957,250.016,295.967,247.967Z",
    transform: "translate(-272.996 -234.837)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M359.963,247.966q2.049-.012,4.1,0,.012,2.049,0,4.1-2.047.012-4.1,0Q359.949,250.015,359.963,247.966Z",
    transform: "translate(-330.43 -234.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M303.965,416.01q4.51,0,9.018,0c.011.544.01,1.091,0,1.636q-4.511,0-9.023,0C303.96,417.1,303.957,416.557,303.965,416.01Z",
    transform: "translate(-280.175 -385.654)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.1 18.044)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M111.989,255.99q2.047-.011,4.093,0,.012,2.046,0,4.092-2.046.014-4.092,0Q111.979,258.036,111.989,255.99Z",
    transform: "translate(-111.984 -255.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M183.994,255.993q2.047-.008,4.1,0,.008,2.047,0,4.1-2.047.009-4.094,0Q183.984,258.041,183.994,255.993Z",
    transform: "translate(-176.607 -255.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M111.989,319.988q2.046-.014,4.092,0,.012,2.047,0,4.093-2.046.012-4.092,0Q111.976,322.033,111.989,319.988Z",
    transform: "translate(-111.983 -313.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M183.992,319.991c1.365-.009,2.728-.005,4.093,0,.008,1.365.006,2.729,0,4.1q-2.047.009-4.1,0C183.986,322.72,183.984,321.356,183.992,319.991Z",
    transform: "translate(-176.603 -313.423)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.ddc7400ecd691466afdb6a90281973b4.svg";
export { ForwardRef as ReactComponent };